module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_Frame01-d2aaea16db47bbd52077dd376733353e.png";